import StartingPage from '../components/starting/StartingPage'

function HomePage() {
  return <StartingPage />
}
export default HomePage